import React from 'react';
import Path from '../../../images/attachment.png';
import { GetImageMeta as GetImageMetaService } from '../../../../../services/2talk/omnichannel';
import FilePresentIcon from '@mui/icons-material/FilePresent';
import './styles.css'

const hasValidMessageId = (id) => {
  const normalizedId = `${id ?? ''}`.trim().toLowerCase();
  return normalizedId !== '' && normalizedId !== 'undefined' && normalizedId !== 'null';
}

function ChatMessageDocument({ content, errorMessage, failed, id, setLoading, src, title }) {
  const canOpenAttachment = hasValidMessageId(id)

  const download = async e => {
    e.preventDefault()
    if (!canOpenAttachment) return

    if (e.target.classList.contains('omnichannel-chat-message-document') || e.target.classList.contains('omnichannel-chat-message-document-icon') || e.target.classList.contains('omnichannel-chat-message-document-name')) {
      setLoading(true)
      let result = await GetImageMetaService(id)
      if (result && result.success && result.data && result.data.url)
        window.open(result.data.url)
      setLoading(false)
    }
  }

  const shortenUrl = (url, max = 40) => {
    if (!url) return "";
    if (url.length <= max) return url;
    
    const start = url.substring(0, 20);
    const end = url.substring(url.length - 10);
    return `${start}...${end}`;
  };

  return (<div
      className={`omnichannel-chat-message-document${canOpenAttachment ? '' : ' omnichannel-chat-message-attachment-disabled'}`}
      onClick={download} >
    <div className="omnichannel-chat-message-document-icon" >
      <FilePresentIcon style={{ color: '#545454', fontSize: '3em' }} />
    </div>
    <div className="omnichannel-chat-message-document-name" >
      {shortenUrl(content)}
      {!canOpenAttachment && <span className={`omnichannel-chat-message-attachment-status${failed ? ' error' : ''}`}>
        {failed ? errorMessage || 'Falha ao enviar o anexo.' : 'Enviando anexo...'}
      </span>}
    </div>
  </div>)
};

export default ChatMessageDocument;
